module.exports = __webpack_public_path__ + "static/media/halloween6.750d0783.jpg";